import { openApp } from "./openApp";

var newOpenApp = function(id, shareType, isnfh, cityRankInfo,clickPosition) {
  openApp(id, shareType, isnfh, cityRankInfo,clickPosition);
};

export { newOpenApp };



// WEBPACK FOOTER //
// ./src/js/newOpenApp.js